import BaseButton from '@/components/Common/DesignSystem/BaseButton/BaseButton';
import IconCommon from '@/components/Common/DesignSystem/Icon/IconCommon';
import { RaffleDealStoreCtx } from '@/stores/RaffleDealStore';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { times } from 'ramda';
import React, { useContext } from 'react';

import styles from './RaffleDealHistoryPagination.module.scss';

const RaffleDealHistoryPagination: React.FC = () => {
  const store = useContext(RaffleDealStoreCtx);

  if (store.totalPages <= 1) {
    return null;
  }

  return (
    <ul className={styles.pagination}>
      <li>
        <BaseButton
          as="button"
          className={clsx([styles.paginationBtn, store.DisabledPrev && styles.disabledPaging])}
          onClick={() => store.clickPrev()}
          disabled={store.DisabledPrev}
        >
          <IconCommon type="icon_arrowback" />
        </BaseButton>
      </li>
      {times((n) => {
        const page = (store.currentPageChapter - 1) * 5 + n + 1;
        return (
          <li key={page} className={styles.page}>
            <a
              onClick={() => {
                store.setCurrentPage(page);
                window.scrollTo(0, 0);
              }}
              className={clsx([page === store.currentPage && styles.activePage])}
            >
              {page}
            </a>
          </li>
        );
      }, store.RenderPageCount)}
      <li>
        <BaseButton
          as="button"
          className={clsx([styles.paginationBtn, store.DisabledNext && styles.disabledPaging])}
          onClick={() => store.clickNext()}
          disabled={store.DisabledNext}
        >
          <IconCommon type="icon_arrowforward_fill" />
        </BaseButton>
      </li>
    </ul>
  );
};

export default observer(RaffleDealHistoryPagination);
